import { useState } from 'react'
import { pluralize } from '../../../utility/helperFunctions'
import PropTypes from 'prop-types'

import SubmitButton from '../../common/buttons/SubmitButton'
import CancelButton from '../../common/buttons/CancelButton'
import Modal from '../../common/Modal'
import MCElement from '../../common/MCElement'

import styles from './AutogenerateModal.module.scss'
import colors from '../../../assets/styles/globals.scss'
import classNames from 'classnames'

const RSVP_STATUSES = { confirmed: 'Attending', declined: 'Not Attending', created: 'No Response', waitlisted: 'Waitlisted' }

const AutogenerateModal = ({ pairedStudentsCount, onSubmit, ...props }) => {
  const [basedOn, setBasedOn] = useState('Age')
  const [studentsIncluded, setStudentsIncluded] = useState({})
  const [keepFilledSlots, setKeepFilledSlots] = useState(true)

  const exitModal = () => {
    props.onClose()
  }

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={exitModal}
      className={styles.autogenerateModalContent}
    >
      <div id='AutogenerateModal'>
        <div className='animated fadeIn'>
          <div>
            <p className={styles.title}>Autogenerate Pairing Groups</p>
            <p>Choose how you want to generate your pairing groups.</p>
            <div className={styles.hl} />
            <div className='row'>
              <div className='col-12'>
                <label htmlFor='basedOn'>Group Students By</label>

                <div
                  onClick={() => setBasedOn('Age')}
                  className='d-flex format-option-tee-times mb-2'
                  role='button'
                  onKeyDown={null}
                  tabIndex={0}
                >
                  <MCElement
                    type='radio'
                    onKeyDown={(e) => {
                      e.key === 'Enter' && setBasedOn('Age')
                    }}
                    primaryColor={basedOn === 'Age' ? colors.secondaryColor : colors.lightNavy}
                    isSelected={basedOn === 'Age'}
                  />
                  <span className='ml-2'>Age</span>
                </div>
                <div
                  onClick={() => setBasedOn('Level')}
                  className='d-flex format-option-Shotgun'
                  role='button'
                  onKeyDown={null}
                  tabIndex={0}
                >
                  <MCElement
                    type='radio'
                    onKeyDown={(e) => {
                      e.key === 'Enter' && setBasedOn('Level')
                    }}
                    primaryColor={basedOn === 'Level' ? colors.secondaryColor : colors.lightNavy}
                    isSelected={basedOn === 'Level'}
                  />
                  <span className='ml-2'>Level</span>
                </div>
              </div>
              <div className='col-12'>
                <label htmlFor='basedOn'>RSVP Status</label>

                {Object.keys(RSVP_STATUSES).map((rsvpStatus, index) => (
                  <div key={index} className='d-flex align-items-center mt-2'>
                    <MCElement
                      type='checkbox'
                      isSelected={studentsIncluded[rsvpStatus]}
                      clicked={() => setStudentsIncluded({ ...studentsIncluded, [rsvpStatus]: !studentsIncluded[rsvpStatus] })}
                      primaryColor={studentsIncluded[rsvpStatus] ? colors.primaryOrange : colors.lightNavy}
                      secondaryColor={colors.whiteColor}
                    />

                    <span className='ml-2 mb-2'>{RSVP_STATUSES[rsvpStatus]}</span>
                  </div>
                ))}
              </div>
              {pairedStudentsCount > 0 &&
                <div className='col-12'>
                  <label htmlFor='basedOn' className={styles.keepFilledSlotsText}>
                    {`You added ${pairedStudentsCount} ${pluralize('golfer', pairedStudentsCount)} to the pairing groups,
                    do you want to keep them there?`}
                  </label>

                  <button
                    className={classNames('btn btn-primary', styles.responseButton, { [styles.selectedButton]: keepFilledSlots === true })}
                    onClick={() => setKeepFilledSlots(true)}
                  >
                    Yes
                  </button>
                  <button
                    className={classNames('btn btn-primary', styles.responseButton, { [styles.selectedButton]: keepFilledSlots === false })}
                    onClick={() => setKeepFilledSlots(false)}
                  >
                    No
                  </button>
                </div>
              }
            </div>
            <div className='row py-3'>
              <div className='col-4'>
                <CancelButton
                  type='button'
                  buttonMessage='Cancel'
                  className='mt-3'
                  onClick={exitModal}
                />
              </div>
              <div className='col-7'>
                <SubmitButton
                  onClick={() => {
                    onSubmit({ basedOn, studentsIncluded, keepFilledSlots })
                    exitModal()
                  }}
                  buttonMessage='Autogenerate'
                  buttonColor='orange-button'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

AutogenerateModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  pairedStudentsCount: PropTypes.number,
}

export default AutogenerateModal
